(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("eppYu", function(module, exports) {

var $f9VXK = parcelRequire("f9VXK");
const $a7d78c87439acf2e$var$initFilterList = ()=>{
    const filterLists = document.querySelectorAll(".js-filter-list");
    filterLists.forEach((list)=>{
        if (!list.dataset.filterTarget) return;
        const targetedForm = document.querySelector(`#${list.dataset.filterTarget}`);
        const targetedCategoryForm = document.querySelector(".f-category");
        const inputs = targetedForm?.querySelectorAll("input");
        const categories = targetedCategoryForm?.querySelectorAll("input");
        const template = list.querySelector("template");
        if (!template || !targetedForm || !inputs) return;
        const checkboxEval = (input, itemOption)=>{
            if (input.checked) (0, $f9VXK.createItem)(itemOption, template, list);
            else (0, $f9VXK.removeItem)(input.id, list);
        };
        const radioEval = (input, itemOption)=>{
            if (input.checked) (0, $f9VXK.createItem)(itemOption, template, list);
            else (0, $f9VXK.removeItem)(input.id, list);
        };
        const rangeEval = (input)=>{
            const rangeWrapper = input.closest(".f-range-slider");
            const rangeWrapperInputs = rangeWrapper?.querySelectorAll(".f-range-slider__range");
            if (!rangeWrapper || !rangeWrapperInputs) return;
            let create = false;
            let title = "";
            rangeWrapperInputs.forEach((input, index)=>{
                if (input.value != input.max && input.value != input.min) create = true;
                title += `${input.value} ${rangeWrapperInputs.length - 1 != index ? "- " : ""}`;
            });
            if (create) (0, $f9VXK.createItem)({
                value: title,
                title: title,
                id: rangeWrapper.id,
                prefix: rangeWrapper.dataset.filterPrefix,
                suffix: rangeWrapper.dataset.filterSuffix
            }, template, list);
            else (0, $f9VXK.removeItem)(rangeWrapper.id, list);
        };
        const inputTypeEval = (input)=>{
            const itemOption = {
                value: input.value,
                title: input.dataset.filterTitle,
                id: input.id,
                prefix: input.dataset.filterPrefix,
                suffix: input.dataset.filterSuffix
            };
            if (input.type === "checkbox") checkboxEval(input, itemOption);
            else if (input.type === "radio") radioEval(input, itemOption);
            else if (input.closest(".f-range-slider")) rangeEval(input);
        };
        inputs.forEach((input)=>{
            input.addEventListener("change", ()=>{
                inputTypeEval(input);
            });
            input.addEventListener("clear", ()=>{
                if (input.type === "checkbox") input.checked = false;
                else input.value = "";
                input.dispatchEvent(new Event("change"));
            });
            inputTypeEval(input);
        });
        categories?.forEach((category)=>{
            category.addEventListener("change", ()=>{
                inputTypeEval(category);
            });
            category.addEventListener("clear", ()=>{
                category.checked = false;
                category.dispatchEvent(new Event("change"));
            });
            inputTypeEval(category);
        });
    });
};
$a7d78c87439acf2e$var$initFilterList();
document.addEventListener("filterListReinit", $a7d78c87439acf2e$var$initFilterList);

});
parcelRegister("f9VXK", function(module, exports) {

$parcel$export(module.exports, "createItem", function () { return $b094a87741d2953e$export$1f768fd5b3313118; });
$parcel$export(module.exports, "removeItem", function () { return $b094a87741d2953e$export$fe2d9b4e03920b4c; });
const $b094a87741d2953e$export$1f768fd5b3313118 = (options, template, parent)=>{
    const clone = template.content.cloneNode(true);
    const title = options.title ?? options.value ?? "";
    const cloneTitle = clone.querySelector(".i-tag__title");
    const cloneElement = cloneTitle?.closest(".i-selected-tag");
    const resetBtn = document?.querySelector(".js-filter-clear");
    if (cloneTitle) cloneTitle.innerHTML = `${options.prefix ?? ""} ${title} ${options.suffix ?? ""}`;
    if (!options.id) return;
    cloneElement?.setAttribute("data-filter-item-target", options.id);
    $b094a87741d2953e$export$fe2d9b4e03920b4c(options.id, parent);
    cloneElement?.addEventListener("click", ()=>{
        document.querySelectorAll(`#${options.id}, #${options.id} input`).forEach((input)=>input.dispatchEvent(new Event("clear")));
    });
    if (cloneElement) parent?.insertBefore(cloneElement, resetBtn);
};
const $b094a87741d2953e$export$fe2d9b4e03920b4c = (id, parent)=>{
    if (!id) return;
    parent.querySelectorAll(`[data-filter-item-target=${id}]`).forEach((item)=>item.remove());
};

});


})();
//# sourceMappingURL=filter-list.0d058542.js.map
